import React, { memo, useEffect, useState } from 'react';
import { Ratio, useTheme } from '@24i/nxg-sdk-higgs';
import { TouchableOpacity } from 'react-native';
import { Icon, View, Image } from '@24i/nxg-sdk-quarks';
import { isPlatformWeb, isFactorTv } from 'renative';
import { PackshotActionButtonProps } from './types';
import getPackshotActionBtnStyles from './styles';

const PackshotActionButton = (props: PackshotActionButtonProps) => {
    const {
        isHighlighted,
        testID,
        actionIcon,
        onPress,
        styles: getStyles = getPackshotActionBtnStyles,
        overrideDisplayIcon = true,
    } = props;
    const { theme } = useTheme();
    const styles = getStyles(theme);

    const [iconSize, setIconSize] = useState<number>(30);
    const [actionIconImage, setActionIconImage] = useState<String>()

    const getIconSize = (icon: string | undefined) => {
        let size = 30
        
        if (isPlatformWeb && isHighlighted) size = 36;

        if (isFactorTv) {
            if (isHighlighted) size = Ratio(80);
            size = Ratio(60);
        }
        if(icon && icon.includes("delete"))size = size-10
        
        return size;
    };

    const getIconImage =(icon: "play" | "cancel" | "delete"):string | undefined=>{
        switch(icon) { 
            case "play": return theme.icons['onTileMainButton-play'].iconImage
            case "cancel": return theme.icons['onButtonPrimary-record_cancel'].iconImage
            case "delete": return theme.icons['onPrimary-delete'].iconImage
            default: return theme.icons['onTileMainButton-play'].iconImage
         } 
    }

    useEffect(() => {
        const icon = getIconImage(actionIcon)
        setIconSize(getIconSize(icon));
        setActionIconImage(icon)
    }, [isHighlighted, actionIcon]);

    if (!actionIcon) return null;

    if (!overrideDisplayIcon) {
        return (
            <TouchableOpacity
                testID={testID}
                onPress={(event) =>
                    isPlatformWeb ? onPress?.(event) : onPress?.({ data: {}, event })
                }
            />
        );
    }

    return (
        <View style={styles.itemActionButtonContainer}>
            <TouchableOpacity
                testID={testID}
                style={[
                    styles.itemActionButton,
                    isHighlighted && styles.itemActionButtonHighlighted,
                ]}
                onPress={(event) =>
                    isPlatformWeb ? onPress?.(event) : onPress?.({ data: {}, event })
                }
            >
                <Image
                    source={actionIconImage}
                    style={{ width: iconSize, height: iconSize }}
                />
            </TouchableOpacity>
        </View>
    );
};

export default memo(PackshotActionButton);
